import React, {PureComponent} from 'react';
import {Button, Input} from '..';

import LockedSVG from 'assets/icons/locked.svg';
import UnlockedSVG from 'assets/icons/unlocked.svg';

import styles from './styles';

const inputProperties = {
  type: 'number',
  step: 1,
  border: true,
  inputStyle: {
    width: '60px'
  }
};

export default class CropSubMenu extends PureComponent {

  constructor(props) {
    super(props);

    const {cropper} = props;
    const {width, height} = cropper.getCropWindow();

    this.state = {
      aspectRatio: cropper.get('ratio'),
      width: Math.round(width),
      height: Math.round(height)
    };
  }

  onCropWindowChanged = (cropWindow) => {
    const width = Math.abs(Math.round(cropWindow.width));
    const height = Math.abs(Math.round(cropWindow.height));

    this.setState({
      width: isNaN(width) ? 0 : width,
      height: isNaN(height) ? 0 : height
    });
  };

  onRatioLockClick = () => {
    const {cropper} = this.props;
    const {aspectRatio} = this.state;
    const {width, height} = cropper.getCropWindow();

    if (aspectRatio) {
      cropper.set('ratio', null);
      this.setState({aspectRatio: null})
    } else {
      const ratio = width / height;

      cropper.set('ratio', ratio || null);
      this.setState({aspectRatio: ratio || null})
    }
  };

  onWidthChange = (value) => {
    const {aspectRatio} = this.state;
    const newWindow = {
      width: parseInt(value, 10)
    };

    if (aspectRatio) {
      newWindow.height = newWindow.width / aspectRatio;
    }

    this.props.cropper
      .setCropWindow(newWindow)
      .draw();
  };

  onHeightChange = (value) => {
    const {aspectRatio} = this.state;
    const newWindow = {
      height: parseInt(value, 10)
    };

    if (aspectRatio) {
      newWindow.width = newWindow.height * aspectRatio;
    }

    this.props.cropper
      .setCropWindow(newWindow)
      .draw();
  };

  onSelectAspectRatio = (ratio) => () => {
    const {cropper} = this.props;
    const {aspectRatio} = this.state;

    if (ratio === aspectRatio || typeof ratio !== 'number') {
      cropper.set('ratio', null);
      this.setState({aspectRatio: null});
    } else {
      cropper.set('ratio', ratio);
      this.setState({aspectRatio: ratio});
    }
  };

  onApply = () => {
    const {cropper} = this.props;

    cropper.applyCrop();
  };

  onReset = () => {
    const {cropper} = this.props;

    cropper.resetCrop();
  };

  componentDidMount() {
    this.props.cropper.on('cropWindowChanged', this.onCropWindowChanged);
  }

  componentWillUnmount() {
    this.props.cropper.off('cropWindowChanged', this.onCropWindowChanged);
  }

  renderAspectRatioLock() {
    const {aspectRatio} = this.state;
    const isLocked = !!aspectRatio;

    return (
      <Button className={styles.largeIcon} onClick={this.onRatioLockClick}>
        {isLocked ? <LockedSVG /> : <UnlockedSVG />}
      </Button>
    );
  }

  renderToggleButton(name, ratio) {
    const {aspectRatio} = this.state;

    return (
      <Button
        className={`toggle-button ${aspectRatio === ratio ? 'selected' : ''}`}
        onClick={this.onSelectAspectRatio(ratio)}
      >
        {name}
      </Button>
    );
  }

  render() {
    const {image} = this.props;
    const {width, height} = this.state;

    return (
      <div className={styles.subMenuContainer}>
        <div className={styles.subMenuSubsection}>
          <Input
            prefix='W'
            value={width}
            onChange={this.onWidthChange}
            {...inputProperties}
          />
          {this.renderAspectRatioLock()}
          <Input
            prefix='H'
            value={height}
            onChange={this.onHeightChange}
            {...inputProperties}
          />
        </div>

        <div className={`${styles.subMenuSubsection} toggle-buttons`}>
          {this.renderToggleButton('Original', image.width / image.height)}
          {this.renderToggleButton('1:1', 1)}
          {this.renderToggleButton('4:3', 4/3)}
          {this.renderToggleButton('16:9', 16/9)}
          {this.renderToggleButton('3:2', 3/2)}
          {this.renderToggleButton('2:1', 2)}
        </div>

        <div className={styles.subMenuSubsection}>
          <Button className='accent-button' onClick={this.onApply}>
            Apply
          </Button>
          <Button className='accent-button' onClick={this.onReset}>
            Reset
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AdjustmentMenu/CropSubMenu.jsx